import SilentRenew from './silent-renew';

const SilentRenewConfig = {
  settings: {
    layout: {
      style: 'layoutFull',
      config: {}
    }
  },
  routes: [
    {
      path: '/silent',
      component: SilentRenew,
      title: '...'
    }
  ]
};

export default SilentRenewConfig;
